<div class="container-fluid px-4">
    <!-- <div class="row pt-4">
        <div class="col-sm-6" [ngClass]="
                this.updatedtheme === 'dark' ? 'headlinetextD' : 'headlinetextL'
            ">
            <h3 class="pl-4">Set Emission Inventory</h3>
        </div>
    </div> -->

    <div class="row pt-3">
        <div class="col-md-12  overflow-auto mb-5 ct_custom_flex_basisc"
            [ngClass]="this.updatedtheme === 'dark' ? 'User-tabD' : 'User-tabL'">
            <div class="row">
                <div class="" [ngClass]="
                        this.updatedtheme === 'dark'
                            ? 'User-headD'
                            : 'User-headL'
                    ">
                    <div
                        class="card-header card-headerL ct_header_grey_1202 d-flex align-items-center justify-content-between">


                        <h4 class=" ct_fw_600 m-0 m-0" style="flex: 1;">Set Emission Inventory</h4>
                        <div class="ct_how_use_tooltip_main ml-auto">
                            <i class="fa-solid fa-circle-question" (click)="isHowtoUse = !isHowtoUse"></i>
                            <div class="ct_how_use_tooltip_cnt" [ngClass]="isHowtoUse ? 'ct_active' : ''">
                                <div>
                                    <p class="mb-1">EKO Trace aligns with science-based target initiative (SBTi) to set the targets for emission reductions.  SBTs are in line with the scale of reductions that the latest climate science deems necessary to keep global warming below 1.5°C.  The goal is to reduce global GHG emissions by 50% by 2030 and reach net zero emissions by no later than 2050. 
                                        Setting SBTs in EKO Trace is a three-step process:
                                        
                                    </p>
                                    <p class="ct_fs_16 mt-2 mb-0"><span class="ct_fw_600">Set Emissions Inventory:</span> An annual emissions inventory is a prerequisite for emissions forecasting and setting targets. The target setting can only be done for the parent company. 	

    
                                    </p>
                        
                                    <ol class="mb-0">
                                        <li>Entering the inventory data 
                                            <ul style="list-style: lower-roman;" class="mb-0">
                                                <li>Inputting scope1, scope2 and scope3 data for the corresponding year is mandatory. Subcategory emissions data is optional and is required only when you are selecting other target KPIs. 
                                                </li>
                                                <li>Product output is required for target type ‘physical intensity convergence.’ This target type is useful in the case of single product manufacturing.  The unit of product output can be no. of items / tonnes / kg etc. 
                                                </li>
                                                <li>Economic output is required for ‘economic intensity convergence’ and is useful when the company generates revenue from multiple products. The unit of economic output is the local ccy of revenue output
                                                </li>
                                            </ul>
                        
                                        </li>
                                        <li>Emissions growth, revenue and output growth projections are required for emissions forecasting. To do the forecasting, you at-least need the base year data (the year when target setting was done), current year (which has latest emissions data) and the target year (by when you want to achieve the target reduction in emissions).

                                        </li>
                                      
                                    </ol>
                                  
                                  
                                </div>
                               
                        
                        
                        
                        
                        
                            </div>
                        </div>
                        <button class="GroupButton ct_assign_package_btn129 ct_animation_btn_121 w-auto px-2 mr-3"
                            (click)="showAddGroupDialog2()">
                            Set Revenue Projections
                        </button>
                        <button class="GroupButton ct_assign_package_btn129 ct_animation_btn_121 w-auto px-4"
                            (click)="showAddGroupDialog()">
                            + Add Inventory
                        </button>
                     
                    </div>
                </div>
                <!-- <div class="d-flex justify-content-between text-style text-light scope-Div">
                    <div class="form-group has-search">
                        <span class="fa fa-search form-control-feedback" [ngClass]="
                                this.updatedtheme === 'dark'
                                    ? 'form-control-feedbackD'
                                    : 'form-control-feedbackL'
                            ">
                        </span>
                        <input type="text" name="search" [ngClass]="
                                this.updatedtheme === 'dark'
                                    ? 'form-controlD'
                                    : 'form-controlL'
                            " class="form-control" placeholder="Search" [(ngModel)]="searchData" />
                    </div>
                    <div class="form-group has-search text-light">
                        <button class="GroupButton ct_assign_package_btn129 ct_animation_btn_121" (click)="showAddGroupDialog()">
                            + Add Offset
                        </button>
                    </div>
                </div> -->
            </div>

            <p-toast></p-toast>
            <p-confirmDialog #cd [style]="{width: '60vw'}">
                <ng-template pTemplate="footer">
                    <button pButton icon="pi pi-check" label="Yes" (click)="cd.accept()"
                        class="span-color cancel-button"></button>
                    <button pButton icon="pi pi-times" label="Cancel" (click)="cd.reject()"
                        class="p-button-raised p-button-danger"></button>
                </ng-template>
            </p-confirmDialog>





            <div class="dataTable scrollit mt-4">
                <table class="table_loc ct_space_table_21 ct_billing_table_bg_120">
                    <thead>
                        <tr>

                            
                            <th scope="col mx-3">Year</th>
                            <th scope="col">Total Scope1 (tC02e)</th>
                            <th scope="col">Total Scope2 (tC02e)</th>
                            <th scope="col">Total Scope3 (tC02e)</th>
                            <th scope="col">Total Emissions (tC02e) </th>
                            <th scope="col">User </th>
                            <th scope="col"> </th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr clickable (click)="selectGroup(group,index)" *ngFor="
                                let group of groupsList;let index = index
                            " class="col-12 tableRow border-bottom rounded pointer" (click)="UnlockComplete(group.id)"
                            [ngClass]="{ 'tableRowclicked': index === selectedRowIndex }">
                            <!-- <td class="td ">
                                {{ group.group_added }}
                            </td> -->
                            <td class="td ">
                                {{ group.year_added }}

                            </td>
                            <td class="td pb-1">
                                {{ group.total_scope1 }}

                            </td>
                            <td class="td pb-1">
                                {{ group.total_scope2 }}

                            </td>
                            <td class="td pb-1">
                                {{ group.total_scope3}}

                            </td>
                            <td class="td pb-1">
                                {{ group.total_emission }}
                            </td>
                            <td class="td pb-1">
                                {{ group.user_name }}
                            </td>
                            <td class="td pb-1" (click)="viewDetails(group.relation_id)">
                                <i class="fas fa-edit"></i>
                            </td>
                            <!-- <td class="td text-right">
                                <a style="
                                        cursor: pointer;
                                        color: #88ad47;
                                        font-size: 13px;
                                    ">view details</a>
                            </td> -->
                        </tr>
                    </tbody>
                </table>
                <div class="text-light" *ngIf="groupdata === false">
                    <div class="icon">
                        <i class="fa fa-info-circle" style="font-size: 20px" aria-hidden="true"></i>
                    </div>
                    <label class="text-center label">No group available. Start by add a new group using the
                        add group button.</label>
                </div>
            </div>
        </div>


    </div>
</div>



<p-dialog (click)="removeCss()" [(visible)]="visible" [breakpoints]="{'960px': '75vw'}" [style]="{width: '50vw'}">
    <p-header *ngIf="FormEdit === false"> Add Inventory</p-header>
    <p-header *ngIf="FormEdit === true"> Edit Carbon Offset </p-header>

    <div class="modal-body text-white text-style Dashboard-tab ct_vertically_scroll">
        <form #GroupForm="ngForm" class="col-12" (ngSubmit)="
            FormEdit === false
                ? saveOffset(GroupForm)
                : updateGroup(relationId, GroupForm)
        ">
            <div class="mb-5 pb-0 row">
                <div class="col-md-6 mb-3">
                    <label for="fname">Year of Emission data</label>
                    <p-calendar class="w-100 ct_input_dark_text_145 ct_calender_input_38_action_12" ngModel
                        name="year_added" [showIcon]="true" view="year" placeholder="Select year" dateFormat="yy"
                        inputId="yearpicker" styleClass="pcalender"></p-calendar>
                        <p class="text-danger mb-0" *ngIf="GroupForm.submitted && !GroupForm.controls['year_added']?.value">
                            Year is required
                        </p>
                </div>
                <div class="col-md-6 mb-3">
                    <label for="fname"> Total Scope 1</label>
                    <input name="scope_1_emissions" ngModel id="search-input" type="text"
                        class="form-control Dashboard-tab text-white" placeholder="Enter emissions"
                        #scope1="ngModel" [disabled]="isloading" required />
                  
                        <p class="text-danger mb-0" *ngIf="GroupForm.submitted && scope1.errors?.['required']">
                            Scope 1 emission is required
                        </p>
                    <p class="text-danger mb-0" *ngIf="
                    isgroupExist === true && groupName.touched
                ">
                        group already exist please use other groupname
                    </p>
                </div>
                <div class="col-md-6 mb-3">
                    <label for="fname"> Total Scope 2</label>
                    <input name="scope_2_emissions" ngModel id="search-input" type="text"
                        class="form-control Dashboard-tab text-white" placeholder="Enter emissions"
                        #scope2="ngModel" [disabled]="isloading" required />
                        <p class="text-danger mb-0" *ngIf="GroupForm.submitted && scope2.errors?.['required']">
                            Scope 2 emission is required
                        </p>
                    <p class="text-danger mb-0" *ngIf="
                    isgroupExist === true && groupName.touched
                ">
                        group already exist please use other groupname
                    </p>
                </div>
                <div class="col-md-6 mb-3">
                    <label for="fname"> Total Scope 3</label>
                    <input name="scope_3_emissions" ngModel id="search-input" type="text"
                        class="form-control Dashboard-tab text-white" placeholder="Enter emissions"
                        #scope3="ngModel" [disabled]="isloading" required />
                        <p class="text-danger mb-0" *ngIf="GroupForm.submitted && scope3.errors?.['required']">
                            Scope 3 emission is required
                        </p>
                    <p class="text-danger mb-0" *ngIf="
                    isgroupExist === true && groupName.touched
                ">
                        group already exist please use other groupname
                    </p>
                </div>
               
                <div class="col-md-12">
                    <div class="ct_inventry_light_bg_1234 py-2 mb-3" style="border-radius: 0px;"></div>
                    <h5 class="mb-3 ">Total Scope1 Emissions (tC02e)</h5>
                    <div class="row">
                        <div class="col-md-6  mb-3">
                            <label for="fname">Scope1 from Company Vehicles</label>
                            <input name="company_vehicles" ngModel id="search-input" type="text"
                                class="form-control Dashboard-tab text-white" placeholder="Enter emission"
                                #groupName="ngModel" [disabled]="isloading"  />
                        </div>
                        <div class="col-md-6  mb-3">
                            <label for="fname">Scope1 from Refrigerants</label>
                            <input name="refrigerants" ngModel id="search-input" type="text"
                                class="form-control Dashboard-tab text-white" placeholder="Enter emission"
                                #groupName="ngModel" [disabled]="isloading"  />
                        </div>
                    </div>
                </div>
              
                <div class="col-md-12 ">
                    <div class="ct_inventry_light_bg_1234 py-2 mb-3" style="border-radius: 0px;"></div>
                    <h5 class="mb-3 ">Total Scope2 Emissions (tC02e)</h5>
                    <!-- <label for="fname">Total Scope2 Emissions (tC02e)</label> -->
                    <div class="row">
                        <div class="col-md-6 mb-3">
                            <label for="fname">Scope2 Location Based Emissions</label>
                            <input name="location_based" ngModel id="search-input" type="text"
                                class="form-control Dashboard-tab text-white" placeholder="Enter emission"
                                #groupName="ngModel" [disabled]="isloading"  />
                        </div>
                        <div class="col-md-6 mb-3">
                            <label for="fname">Scope2 Renewable Energy Use</label>
                            <input ngModel name="renewable" id="search-input" type="text"
                                class="form-control Dashboard-tab text-white " placeholder="Enter emission"
                                #groupName="ngModel" [disabled]="isloading"  />
                        </div>
                    </div>
                </div>
        
                <div class="col-md-12 ">
                    <div class="ct_inventry_light_bg_1234 py-2 mb-3" style="border-radius: 0px;"></div>
                    <h5 class="mb-3 ">Total Scope3 Emissions (tC02e)</h5>
                    <!-- <label for="fname">Total Scope3 Emissions (tC02e)</label> -->
                    <div class="row">
                        <div class="col-md-6 mb-3">
                            <label for="fname">Purchased goods and services</label>
                            <input name="purchased_goods" ngModel id="search-input" type="text"
                                class="form-control Dashboard-tab text-white" placeholder="Enter emission"
                                #groupName="ngModel" [disabled]="isloading"  />
                        </div>
                        <div class="col-md-6 mb-3">
                            <label for="fname">Business travel and employee commute</label>
                            <input ngModel name="business_travel" id="search-input" type="text"
                                class="form-control Dashboard-tab text-white " placeholder="Enter emission"
                                #groupName="ngModel" [disabled]="isloading"  />
                        </div>
                        <div class="col-md-6 mb-3">
                            <label for="fname">Waste generated in operations</label>
                            <input ngModel name="waste_generated" id="search-input" type="text"
                                class="form-control Dashboard-tab text-white " placeholder="Enter emission"
                                #groupName="ngModel" [disabled]="isloading"  />
                        </div>
                        <div class="col-md-6 mb-3">
                            <label for="fname">Water Usage</label>
                            <input ngModel name="waste" id="search-input" type="text"
                                class="form-control Dashboard-tab text-white " placeholder="Enter emission"
                                #groupName="ngModel" [disabled]="isloading"  />
                        </div>
                        <div class="col-md-6 mb-3">
                            <label for="fname">Production output</label>
                            <input ngModel name="production_output" id="search-input" type="number"
                                class="form-control Dashboard-tab text-white " placeholder="Enter production output"
                                #productionOutput="ngModel" [disabled]="isloading" required />
                                <p class="text-danger mb-0" *ngIf="GroupForm.submitted && productionOutput.errors?.['required']">
                                    Field is required
                                </p>
                        </div>
                        <div class="col-md-6 mb-3">
                            <label for="fname">Economic output</label>
                            <input ngModel name="economic_output" id="search-input" type="number"
                                class="form-control Dashboard-tab text-white " placeholder="Enter economic output"
                                #economic="ngModel" [disabled]="isloading" required />
                                <p class="text-danger mb-0" *ngIf="GroupForm.submitted && economic.errors?.['required']">
                                    Field is required
                                </p>
                        </div>
                    </div>
                </div>
        
                <div class="col-md-12 ">
                    <div class="ct_inventry_light_bg_1234 py-2 mb-3" style="border-radius: 0px;"></div>
                    <h5 class="mb-3 ">Carbon Offsets (tC02e) (optional)</h5>
                    <input name="carbonOffset" ngModel id="search-input" type="number"
                    class="form-control Dashboard-tab text-white mb-3" placeholder="Enter emission"
                    #groupName="ngModel" [disabled]="isloading"  />
                    <!-- <label for="fname">Total Scope3 Emissions (tC02e)</label> -->
                    <div class="row">
                        <div class="col-md-6 mb-3">
                            <label for="fname">Allocation to Scope 1</label>
                            <input name="allocatedScope1" ngModel id="search-input" type="number"
                                class="form-control Dashboard-tab text-white" placeholder="Enter emission %"
                                #groupName="ngModel" [disabled]="isloading"  />
                        </div>
                        <div class="col-md-6 mb-3">
                            <label for="fname">Allocation to Scope 2 </label>
                            <input ngModel name="allocatedScope2" id="search-input" type="number"
                                class="form-control Dashboard-tab text-white " placeholder="Enter emission %"
                                #groupName="ngModel" [disabled]="isloading"  />
                        </div>
                        <div class="col-md-6 mb-3">
                            <label for="fname">Allocation to Scope 3</label>
                            <input ngModel name="allocatedScope3" id="search-input" type="number"
                                class="form-control Dashboard-tab text-white " placeholder="Enter emission %"
                                #groupName="ngModel" [disabled]="isloading"  />
                        </div>
                    </div>
                </div>
            </div>


            <div class="mt-3 ct_modal_btns_12">
                <Button (click)="removeCss()" type="submit" *ngIf="FormEdit === false" [disabled]="
                    (this.selectedRole !== Roleaccess &&
                        facilitydata === true) ||
                    usernameIsExist === true ||
                    emailIstExist === true
                " class="rounded span-color px-3 text-white text-style loading ">
                    <p-progressSpinner strokeWidth="8" *ngIf="isloading === true"></p-progressSpinner>
                    Save
                </Button>
                <Button *ngIf="FormEdit === true" type="submit " class="rounded span-color px-3 text-white text-style ">
                    <p-progressSpinner strokeWidth="8" *ngIf="isloading === true"></p-progressSpinner>
                    Update
                </Button>

                <span type="button" class="text-white font-weight-light ml-3 " (click)="removeCss()"
                    (click)="onCloseHandled()">
                    Close
                </span>
            </div>
        </form>
    </div>
</p-dialog>


<p-dialog (click)="removeCss()" [(visible)]="visible2" [breakpoints]="{'960px': '75vw'}" [style]="{width: '50vw'}">
    <p-header *ngIf="FormEdit === false">Set Projections</p-header>
    <!-- <p-header *ngIf="FormEdit === true"> Edit Carbon Offset </p-header> -->

    <div class="modal-body text-white text-style Dashboard-tab ct_vertically_scroll">
        <form #projectionForm="ngForm" class="col-12" (ngSubmit)="
            FormEdit === false
                ? saveProjections(projectionForm)
                : updateGroup(relationId, GroupForm)
        ">
            <div class="mb-5 pb-0 row">
                <div class="col-md-12 mb-3">
                    <table class="table_loc ct_space_table_21 ct_billing_table_bg_120">
                        <thead>
                            <tr>
                                <th scope="col">Emissions Forecasting </th>
                                <th scope="col">Percentage</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr 
                                 class="col-12 tableRow border-bottom rounded pointer" 
                               >
                                <td class="td ">
                                    Emissions change (per annum)
                                </td>
                                <td class="td"><input type="text" ngModel class="form-control Dashboard-tab text-white" name="factor1" id="" placeholder="Enter % of growth"></td>
                            </tr>
                            <tr 
                                 class="col-12 tableRow border-bottom rounded pointer" 
                               >
                                <td class="td ">
                                    Revenue growth (per annum)
                                </td>
                                <td class="td"><input type="text" ngModel class="form-control Dashboard-tab text-white" name="factor2" id="" placeholder="Enter % of growth"></td>
                            </tr>
                            <tr 
                                 class="col-12 tableRow border-bottom rounded pointer" 
                               >
                                <td class="td ">
                                    Output growth (per annum)
                                </td>
                                <td class="td"><input type="text" ngModel    class="form-control Dashboard-tab text-white" name="factor3" id="" placeholder="Enter % of growth"></td>
                            </tr>
                        </tbody>
                    </table>
                </div>
               
                <div class="col-md-12">
                    
                </div>
               
            </div>


            <div class="mt-3 ct_modal_btns_12">
                <Button (click)="removeCss()" type="submit" *ngIf="FormEdit === false" [disabled]="
                    (this.selectedRole !== Roleaccess &&
                        facilitydata === true) ||
                    usernameIsExist === true ||
                    emailIstExist === true
                " class="rounded span-color px-3 text-white text-style loading ">
                    <p-progressSpinner strokeWidth="8" *ngIf="isloading === true"></p-progressSpinner>
                    Save
                </Button>
                <Button *ngIf="FormEdit === true" type="submit " class="rounded span-color px-3 text-white text-style ">
                    <p-progressSpinner strokeWidth="8" *ngIf="isloading === true"></p-progressSpinner>
                    Update
                </Button>

                <span type="button" class="text-white font-weight-light ml-3 " (click)="removeCss()"
                    (click)="onCloseHandled()">
                    Close
                </span>
            </div>
        </form>
    </div>
</p-dialog>